import React from 'react'
import PropTypes from 'prop-types'

import Carousel from 'react-multi-carousel'
import { createUseStyles } from 'react-jss'

import { useCurrentWidth, isClientSide } from '../Common/utils'

import SVG from '../SVG/SVG'
import Gtm from '../../../utils/gtm'
import { loggingEnabled } from '../../../utils/logging'

const responsive = {
  desktop: {
    breakpoint: { max: 4000, min: 0 },
    items: 1,
  },
}

const ButtonGroup = ({ next, previous, ...rest }) => {
  const classes = useStyles()
  return (
    <div className={classes.carouselCustomArrows}>
      <button
        className={classes.carouselCustomArrowsLeft}
        onClick={() => {
          previous()
        }}
      >
        <SVG name={'Chevron'} width={14} height={30} />
      </button>
      <button
        className={classes.carouselCustomArrowsRight}
        onClick={() => {
          next()
        }}
      >
        <SVG name={'Chevron'} width={14} height={30} />
      </button>
    </div>
  )
}

const useStyles = createUseStyles(theme => ({
  wrapperDesign: {
    ...theme.wrappers.standard,
  },
  shadowbg: {
    '@media (max-width: 600px)': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundImage: 'linear-gradient(360deg, rgba(0,0,0,0.6) 30%, transparent 50%)',
      backgroundRepeat: 'no-repeat',
    },
  },
  velocityLogo: {
    marginBottom: '55px',
    '@media (max-width: 600px)': {
      marginBottom: '115px',
      '& img': {
        width: 119,
        height: 43,
      },
    },
  },
  hero: {
    position: 'relative',
  },
  carouselCustomArrows: {
    top: 0,
    position: 'absolute',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
  },
  carouselCustomArrowsLeft: {
    textAlign: 'center',
    paddingRight: 9,
    borderRadius: '50%',
    backgroundColor: theme.colors.white,
    height: 30,
    width: 30,
    zIndex: 1,
    position: 'absolute',
    cursor: 'pointer',
    pointerEvents: 'all',
    boxShadow: 'none',
    border: 'none',
    textShadow: 'none',
    margin: '-2em',
    top: 'calc(50% - 23px)',
    left: 'calc((100% - 1440px)/2)',

    '@media (max-width: 1485px)': {
      left: 65,
    },

    '@media (max-width: 600px)': {
      // display: 'none',
      left: 5,
      padding: 0,
      margin: 0,
    },

    '& svg': {
      transform: 'rotate(180deg) scale(0.75)',
      transformOrigin: 'center',
      fill: theme.colors.blue,
    },
    '&:hover': {
      backgroundColor: theme.colors.blue,
      '& svg': {
        fill: theme.colors.white,
      },
    },
  },
  carouselCustomArrowsRight: {
    paddingLeft: 9,
    textAlign: 'center',
    borderRadius: '50%',
    backgroundColor: theme.colors.white,
    height: 30,
    width: 30,
    zIndex: 1,
    position: 'absolute',
    cursor: 'pointer',
    pointerEvents: 'all',
    boxShadow: 'none',
    border: 'none',
    textShadow: 'none',
    margin: '-2em',
    top: 'calc(50% - 23px)',
    right: 'calc((100% - 1440px)/2)',

    '@media (max-width: 1485px)': {
      right: 65,
    },
    '@media (max-width: 600px)': {
      right: 5,
      padding: 0,
      margin: 0,
    },
    '& svg': {
      transform: 'scale(0.75)',
      transformOrigin: 'center',
      fill: theme.colors.blue,
    },
    '&:hover': {
      backgroundColor: theme.colors.blue,
      '& svg': {
        fill: theme.colors.white,
      },
    },
  },
  heroSliderSlide: {
    width: '100%',
    height: '100%',
    minHeight: 624,
    display: 'flex',
    alignItems: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    '@media (max-width: 600px)': {
      minHeight: 375,
    },
  },

  heroSliderSlideWrapper: {
    ...theme.wrappers.standard,
    padding: '0 150px',
    width: '100%',
    '&.velocity': {
      padding: '0 20px',
    },
    '@media (max-width: 600px)': {
      padding: '0 25px',
      '&.velocity': {
        position: 'relative',
        zIndex: 9,
      },
    },
  },
  heroSliderSlideInner: {
    maxWidth: 600,
    width: '100%',
    textAlign: 'left',
    boxSizing: 'border-box',
    marginLeft: 20,
    '&.velocity': {
      maxWidth: 750,
    },
    '@media (max-width: 600px)': {
      marginLeft: 0,
    },
    '& .textBlack': {
      '& span': {
        color: theme.colors.black,
      },
    },
    '& .backBlack': {
      '& span': {
        background: theme.colors.black,
      },
    },
    '& .textWhite': {
      '& span': {
        color: theme.colors.white,
        backgroundColor: 'transparent !important',
      },
    },
    '& .backWhite': {
      '& span': {
        background: theme.colors.white,
      },
    },
    '& .textBlue': {
      '& span': {
        color: theme.colors.blue,
      },
    },
    '& .backBlue': {
      '& span': {
        background: theme.colors.blue,
      },
    },
    '& .textYellow': {
      '& span': {
        color: theme.colors.yellow,
      },
    },
    '& .backYellow': {
      '& span': {
        background: theme.colors.yellow,
      },
    },
    '& .textHeading': {
      fontFamily: 'TTRounds',
      fontSize: '54px',
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.2',
      letterSpacing: 'normal',
      backgroundColor: 'transparent',
      color: '#fff',
      display: 'inline',
      padding: '0',
      // lineHeight: "54px",

      '& span': {
        lineHeight: '1.8',
        padding: 0,
      },

      '@media (max-width: 600px)': {
        fontSize: 34,
      },
      '&.velocity': {
        fontFamily: 'Montserrat',
        fontSize: '54px',
        '@media (max-width: 600px)': {
          fontSize: 24,
          lineHeight: '30px',
        },
      },
    },
    '& .textLight': {
      fontSize: 20,
      fontWeight: 300,
      color: '#fff',
      display: 'inline',
      padding: '0',
      lineHeight: '35px',

      '& span': {
        lineHeight: '50px',
        padding: 0,
      },

      '@media (max-width: 600px)': {
        fontSize: 19,
        lineHeight: '28px',
      },
    },
    '& .textBold': {
      fontSize: 20,
      fontWeight: 500,
      color: '#000000',
      display: 'inline',
      padding: '0',
      lineHeight: '35px',

      '& span': {
        lineHeight: '50px',
        padding: 0,
      },

      '@media (max-width: 600px)': {
        fontSize: 19,
        lineHeight: '28px',
      },
    },
  },
  heroSliderTrack: {
    width: '100%',
  },
  underline: {
    textDecoration: 'underline',
  },
  sliderButton: {
    paddingTop: 20,
  },
  textDetails: {
    marginTop: 10,
    maxWidth: 500,
    lineHeight: 1.5,
    color: theme.colors.white,
    fontWeight: 200,
    '@media (max-width: 600px)': {
      display: 'none',
    },
  },
  heroSlider: {
    '& .react-multi-carousel-dot-list': {
      bottom: 25,
    },
    '& .react-multi-carousel-dot button': {
      border: 'none !important',
      backgroundColor: 'rgba(255, 255, 255, 0.5) !important',
      width: 10,
      height: 10,
      margin: '0 5px',
    },
    '& .react-multi-carousel-dot--active button': {
      border: 'none !important',
      backgroundColor: '#FFFFFF !important',
      width: 10,
      height: 10,
      margin: '0 5px',
    },
  },

  buttonCta: {
    borderRadius: '15px',
    padding: '12px 22px 10px',
    fontSize: '14px',
    lineHeight: '19px',
    fontWeight: 300,
    fontFamily: 'TTRounds',
    color: '#2D2D2D',
    border: 'none',
    backgroundColor: '#fff',
    textDecoration: 'none',
    display: 'inline-block',
    '&:hover': {
      backgroundColor: '#E8E8E8',
      textDecoration: 'none',
    },
  },
  buttonCtaVelo: {
    padding: '14px 42px 12px',
    fontSize: '14px',
    lineHeight: '19px',
    fontWeight: 300,
    fontFamily: 'TTRounds',
    color: '#fff',
    border: 'none',
    backgroundColor: '#E10A0A',
    textDecoration: 'none',
    display: 'inline-block',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#E10A0A',
      textDecoration: 'none',
    },
    '@media (max-width: 600px)': {
      padding: '10px 32px 8px',
    },
  },
}))

export const HeroSlider = ({ slides }) => {
  const classes = useStyles()
  const gtm = new Gtm(loggingEnabled)

  const currentWidth = useCurrentWidth()
  const isMobile = currentWidth < 680

  return (
    <div className={classes.hero}>
      <Carousel
        className={classes.heroSlider}
        infinite={slides.length > 1}
        showDots={slides.length > 1}
        autoPlay={slides.length > 1}
        arrows={false}
        responsive={responsive}
        ssr={!isClientSide()}
        deviceType={isClientSide() ? null : 'desktop'}
        autoPlaySpeed={5000}
        renderButtonGroupOutside={!isMobile && slides.length > 1}
        customButtonGroup={isMobile || slides.length < 2 ? undefined : <ButtonGroup />}
        sliderClass={isClientSide() ? '' : classes.heroSliderTrack}
      >
        {slides.map((slide, outsideIndex) => (
          <div
            key={`slide-${outsideIndex}`}
            className={classes.heroSliderSlide}
            style={{
              backgroundImage: `url("${
                isMobile && slide.imageSrcMobile !== '' ? slide.imageSrcMobile : slide.imageSrc
              }")`,
            }}
          >
            {slide.velocityDesign == '1' ? (
              <>
                <div className={classes.shadowbg} />
                <div className={`${classes.heroSliderSlideWrapper} velocity`}>
                  <div className={`${classes.heroSliderSlideInner} velocity`}>
                    <div className={classes.velocityLogo}>
                      <img src="/themes/thrifty/assets/images/va-logo.png" alt="velocity" />
                    </div>
                    <div>
                      <p className="textWhite textHeading velocity">{slide.title}</p>
                      {/* <div className={`${classes.sliderButton} velocity`}>
                        <a
                          href={slide.buttonHref}
                          className={classes.buttonCtaVelo}
                          id="book-now"
                          onClick={() => {
                            gtm.homepageCTA()
                            gtm.sliderClick(slide.buttonText, slide.title)
                          }}
                        >
                          {slide.buttonText}
                        </a>
                      </div> */}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div className={classes.heroSliderSlideWrapper}>
                <div className={classes.heroSliderSlideInner}>
                  <p className="textWhite textHeading">{slide.title}</p>
                  <p className={classes.textDetails}>{slide.text}</p>
                  {slide.buttonHref != '' && (
                    <div className={classes.sliderButton}>
                      <a
                        href={slide.buttonHref}
                        className={classes.buttonCta}
                        onClick={() => {
                          gtm.homepageCTA()
                          gtm.sliderClick(slide.buttonText, slide.title)
                        }}
                      >
                        {slide.buttonText}
                      </a>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
      </Carousel>
    </div>
  )
}

HeroSlider.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      imageSrc: PropTypes.string,
      text: PropTypes.string,
      title: PropTypes.string,
      buttonText: PropTypes.string,
      buttonHref: PropTypes.string,
    }),
  ),
}

export default HeroSlider
